import styled from 'styled-components';

export const StyledButton = styled.button`
  background-color: white;
  border-radius: 20px;
  cursor: pointer;
  padding: 10px 15px 10px 15px;
  font-weight: bold;

  &:hover {
    background-color: #e6e6e6;
  }

  &:disabled {
    background-color: #f0f0f0;
    cursor: not-allowed;
    opacity: 0.6;
    border: 4px solid #666666;
    color: #666666;

    &:hover {
      background-color: #f0f0f0;
    }
  }
`;

export const StyledSpinner = styled.div`
  border: 10px solid var(--Dropzone-color);
  border-top: 10px solid var(--Header-color);
  border-radius: 50%;
  width: 80px;
  height: 80px;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const StyledInput = styled.input`
  border: 6px solid var(--Dropzone-color);
  background-color: var(--Dropzone-color);
  border-radius: 10px;
  font-size: 20px;
`;
